
import MarqueeLogoSlider from "../../components/rebranding/MarqueeLogoSlider.vue";

export default {
  components: { MarqueeLogoSlider },
};
